import $foreign from "./foreign.cjs";
var $$null = $foreign.null;
var $$undefined = $foreign.undefined;
export { $$null as null, $$undefined as undefined };
